<template>
  <div id="app">
    <!-- <router-view></router-view> -->
    <first-view></first-view>
  </div>
</template>

<script>
import firstView from "./modules/firstView";
export default {
  name: "App",
  data() {
    return {};
  },
  components: {
    firstView
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
    width: 100%;
    height: 100%;
}
</style>
